module.exports = __webpack_public_path__ + "img/team2.d0da3491.png";